
import React from 'react'
import { TextField, Tooltip } from '@material-ui/core'

const HoverableTextField = props => <Tooltip title={props.value}><TextField {...props} /></Tooltip>
export default HoverableTextField;
